import { useQuery } from 'react-query';
import hash from 'object-hash';
import { UserType } from '../types/types';

const baseRoute = process.env.REACT_APP_BASE_URL;

export interface AddPagosPayloadType {
  anio: number;
  mes: number;
  user: string;
  monto: number;
  montoEfectivo?: number;
  montoTransferencia?: number;
  obs: string;
  alumnoId: string;
  fecha: string;
  transferencia: boolean;
  saldado: boolean;
  esMatricula?: boolean;
  esSeguro?: boolean;
}

async function addPagoApiCall(params?: AddPagosPayloadType[] | null, user?: UserType | null) {
  if (!user?.token) return null;
  if (params === null) return null;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/pagos`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}

export function UseAddPAgo(params:AddPagosPayloadType[] | null, user?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['addPago', hash(params ?? ''), hash(user ?? '')],
    () => addPagoApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

async function deletePagoApiCall(id?: string | null, fecha?: string | null, user?: UserType | null) {
  if (!user?.token || !id || !fecha) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/pagos?id=${id}&fecha=${fecha}`,
    { headers, method: 'DELETE' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}

export function UseDeletePago(id?: string | null, fecha?: string | null, user?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['deletePAgo', id, hash(user ?? ''), fecha],
    () => deletePagoApiCall(id, fecha, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

export interface EditPagoParams { id: string, field: string, value: any }

async function editPagoApiCall(params?: EditPagoParams[] | null, user?: UserType | null) {
  if (!user?.token) return null;
  if (params === null) return null;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/pagos/edit`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}


export function UseEditPAgos(params?:EditPagoParams[] | null, user?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['addPago', hash(params ?? ''), hash(user ?? '')],
    () => editPagoApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

